import { cn } from "@/lib/utils";
import { faviconUrl } from "@/utils/url";
import { GlobeIcon } from "lucide-react";
import { useState } from "react";

/**
 * The logo of a cited site, the way ChatGPT marks its sources, from the same
 * favicon service the research card already uses. The host comes from a URL a
 * search returned, never from the model's text. A site with no favicon, or a
 * service that does not answer, falls back on a globe rather than a broken
 * image — for that host only: a pill whose first source changes while the
 * answer streams tries the new site's logo. No referrer: the page's URL names
 * the conversation, and it is none of the favicon service's business.
 */
export function SourceFavicon({
  host,
  className,
}: {
  readonly host: string;
  readonly className?: string;
}) {
  const [failedHost, setFailedHost] = useState<string | null>(null);

  if (failedHost === host) {
    return (
      <GlobeIcon aria-hidden="true" className={cn("size-3 shrink-0", className)} />
    );
  }
  return (
    <img
      src={faviconUrl(host)}
      alt=""
      loading="lazy"
      referrerPolicy="no-referrer"
      className={cn("size-3 shrink-0 rounded-[2px]", className)}
      onError={() => setFailedHost(host)}
    />
  );
}
